import { useMemo } from "react";
import { bool, func, number } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  useEstimateStructure,
  CollapseValueInnerCell,
  ResetValueButton
} from "@tools";

export const MonthValueCell = observer(({
  value: monthlyValue=0,
  month,
  maxHours,
  hasOverride,
  displayContent,
  displayCellContent,
  handleReset,
  handleValueChange,
  isOpened,
  readOnly,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { allowEdition } = useEstimateEditorSettings();
  const { usedRoundDecimals } = structure.settings;
  
  const displayResetButton = useMemo(() => (
    hasOverride && displayContent && allowEdition && !readOnly && !isOpened && handleReset
  ), [hasOverride, displayContent, allowEdition, readOnly, isOpened, handleReset]);
  
  const displayedValue = useMemo(() => (
    displayCellContent && (hasOverride || monthlyValue)
      ? monthlyValue
      : ""
  ), [displayCellContent, hasOverride, monthlyValue]);
  
  const localMaxHours = useMemo(() => (
    maxHours + (hasOverride ? monthlyValue : 0)
  ), [maxHours, hasOverride]);
  
  return (
    <CollapseValueInnerCell
      value={displayedValue}
      max={localMaxHours}
      displayContent={displayContent}
      displayCellContent={displayCellContent}
      showDecimals
      editable={!readOnly && allowEdition}
      textPresetClass="preset-timelineText"
      onValueChange={handleValueChange}
      decimals={usedRoundDecimals}
      inputClassName={ `input-month${month+1}` }
      navigationKey={`tm-month${month+1}`}
    >
      {displayResetButton && (
        <ResetValueButton action={handleReset}>
          {t("views.editor.revert_value")}
        </ResetValueButton>
      )}
    </CollapseValueInnerCell>
  )
})

MonthValueCell.propTypes = {
  month: number.isRequired,
  value: number,
  maxHours: number,
  hasOverride: bool,
  displayContent: bool,
  displayCellContent: bool,
  handleReset: func,
  handleValueChange: func,
  isOpened: bool,
  readOnly: bool,
}